import { render, staticRenderFns } from "./ProcessStatistics.vue?vue&type=template&id=1a059115&scoped=true"
import script from "./ProcessStatistics.vue?vue&type=script&lang=js"
export * from "./ProcessStatistics.vue?vue&type=script&lang=js"
import style0 from "./ProcessStatistics.vue?vue&type=style&index=0&id=1a059115&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a059115",
  null
  
)

export default component.exports